import { type Pool } from '@cetusprotocol/cetus-sui-clmm-sdk';
import { cetusClmmSDK } from '@libs/cetus.client';
import { useEffect, useState } from 'react';

export const usePool = (poolId: string) => {
  const [pool, setPool] = useState<Pool>();

  const getPool = async () => {
    if (!poolId) {
      setPool(undefined);
      return;
    }
    const cetusPool = await cetusClmmSDK.Pool.getPool(poolId);
    setPool(cetusPool);
  };

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    const loop = () => {
      getPool();
      timer = setTimeout(() => {
        loop();
      }, 60_000);
    };
    loop();
    return () => {
      clearTimeout(timer);
    };
  }, [poolId]);

  return {
    pool,
  };
};
